module.exports = __webpack_public_path__ + "img/kws_blue.63d97c17.svg";